import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import VerificationPage from "../pages/VerificationPage/VerificationPage";

var NormalUserRoutes = [
  {
    path: "*",
    name: "Verification",
    element: <VerificationPage/>,
    layout: "user",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default NormalUserRoutes;
